module.exports = __webpack_public_path__ + "static/img/7_1.60b984d1.jpg";